export const HOTMART_APP_ANDROID_URL =
  'https://play.google.com/store/apps/details?id=com.hotmart.sparkle&hl=pt_BR&pli=1'

export const HOTMART_APP_IOS_URL = 'https://apps.apple.com/br/app/hotmart/id1066849827'
